var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#movie-clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3555 1.80469H0.644531C0.288528 1.80469 0 2.09322 0 2.44922V19.5269C0 19.8829 0.288528 20.1715 0.644531 20.1715H21.3555C21.7115 20.1715 22 19.8829 22 19.5269V2.44922C22 2.09322 21.7115 1.80469 21.3555 1.80469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4727V19.5271C0 19.8831 0.288528 20.1717 0.644531 20.1717H21.3555C21.7115 20.1717 22 19.8831 22 19.5271V16.4727H0ZM3.49037 18.8826H1.28906V17.7604H3.49037V18.8826ZM6.94214 18.8826H4.77943V17.7604H6.94214V18.8826ZM10.3939 18.8826H8.2312V17.7604H10.3939V18.8826ZM13.8458 18.8826H11.683V17.7604H13.8458V18.8826ZM17.2976 18.8826H15.1349V17.7604H17.2976V18.8826ZM20.7109 18.8826H18.5867V17.7604H20.7109V18.8826Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5.5052V2.44922C22 2.09338 21.7115 1.80469 21.3555 1.80469H0.644531C0.288528 1.80469 0 2.09338 0 2.44922V5.5052H22ZM18.5867 3.09375H20.7109V4.21597H18.5867V3.09375ZM15.1349 3.09375H17.2976V4.21597H15.1349V3.09375ZM11.683 3.09375H13.8458V4.21597H11.683V3.09375ZM8.2312 3.09375H10.3939V4.21597H8.2312V3.09375ZM4.77943 3.09375H6.94214V4.21597H4.77943V3.09375ZM1.28906 3.09375H3.49037V4.21597H1.28906V3.09375Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.4727H0V19.5271C0 19.8831 0.288528 20.1717 0.644531 20.1717H11V16.4727ZM3.49037 18.8826H1.28906V17.7604H3.49037V18.8826ZM6.94214 18.8826H4.77943V17.7604H6.94214V18.8826ZM8.2312 18.8826V17.7604H10.3939V18.8826H8.2312Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.80469H0.644531C0.288528 1.80469 0 2.09322 0 2.44922V5.5052H11V1.80469ZM3.49037 4.21597H1.28906V3.09375H3.49037V4.21597ZM6.94214 4.21597H4.77943V3.09375H6.94214V4.21597ZM8.2312 4.21597V3.09375H10.3939V4.21597H8.2312Z",
    fill: "#29353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3836 10.3243C13.3662 10.3116 13.3479 10.2997 13.3291 10.2888L9.64114 8.13596C9.37393 7.96124 9.0228 7.94143 8.7341 8.08846C8.44977 8.23298 8.27319 8.51513 8.27319 8.82464V13.1522C8.27319 13.4617 8.44977 13.7437 8.7341 13.8884C8.86334 13.9542 9.00517 13.9866 9.14633 13.9866C9.32039 13.9866 9.49361 13.9374 9.64114 13.8407L13.3291 11.6881C13.3479 11.6772 13.3662 11.6653 13.3836 11.6525C13.6017 11.4936 13.7269 11.2517 13.7269 10.9885C13.7269 10.7253 13.6017 10.4831 13.3836 10.3243Z",
    fill: "#5FB4D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "movie-clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.2eb5d9fd2f5f979f117197bad8d07968.svg";
export { ForwardRef as ReactComponent };